import React from "react";
import { Link } from "react-router-dom";
import { MarketingNav } from "@/components/marketing/MarketingNav";
import { MarketingFooter } from "@/components/marketing/MarketingFooter";

export function TermsPage() {
  const lastUpdated = "February 14, 2026";

  return (
    <div className="cb-root">
      <MarketingNav />

      <section className="mx-auto w-full max-w-3xl px-5 pt-24 pb-20 sm:px-8 sm:pt-32">
        <div className="mb-10">
          <p data-testid="cb-terms-updated" className="text-xs font-semibold uppercase tracking-[0.22em] text-[#c8ff00]">
            Last updated: {lastUpdated}
          </p>
          <h1
            data-testid="cb-terms-heading"
            className="cb-display mt-3 text-4xl leading-[1.05] text-white sm:text-5xl"
          >
            Terms of Service
          </h1>
          <p className="mt-4 text-base leading-relaxed text-[#8a8a90]">
            These Terms of Service (&quot;Terms&quot;) govern your access to and use of
            ClippingBase (&quot;service&quot;, &quot;platform&quot;), operated by ClippingBase. By creating
            an account or otherwise using the service you agree to these Terms.
          </p>
        </div>

        <div className="cb-legal-body space-y-8 text-[15px] leading-relaxed text-[#c8c8cc]">
          <section>
            <h2 className="mb-3 text-xl font-bold text-white">1. Who can use ClippingBase</h2>
            <p>You must be at least 13 (or 16 in the EU/UK) to use ClippingBase, and old enough under your local law to enter into a binding contract. You are responsible for keeping your account credentials secure.</p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">2. How the service works</h2>
            <p>ClippingBase is a marketplace connecting brands with content creators (&quot;clippers&quot;). Brands post campaigns; clippers submit clips they publish on their own social accounts (Instagram, TikTok, YouTube). We measure views/likes on those clips and pay clippers according to each campaign&apos;s stated rate.</p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">3. Your responsibilities</h2>
            <ul className="ml-5 list-disc space-y-1.5">
              <li>You must own or have permission to publish any content you submit.</li>
              <li>You must comply with the terms of each social platform (Instagram, TikTok, YouTube) — we do not enable, encourage or condone violation of those terms.</li>
              <li>You may not artificially inflate views, likes or engagement (view-bots, click-farms, sub-for-sub schemes, etc.).</li>
              <li>You may not connect a social account you do not own.</li>
              <li>You may not resell, sublicense or scrape ClippingBase data.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">4. Payouts</h2>
            <p>Payouts are calculated from the public metrics of your clips, according to the rate posted on each campaign. Metrics are counted after any platform-side flag / review windows. Fraudulent metrics may be discarded and the associated payout reversed.</p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">5. Termination</h2>
            <p>We may suspend or terminate your account if you materially breach these Terms, engage in fraud, or violate any social platform&apos;s policies while submitting clips through ClippingBase. You may close your account at any time from{" "}
              <Link to="/settings" className="text-[#c8ff00] underline">Settings</Link>{" "}or by writing to{" "}
              <a href="mailto:support@clippingbase.com" className="text-[#c8ff00] underline">support@clippingbase.com</a>.
            </p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">6. Warranty &amp; liability</h2>
            <p>The service is provided &quot;as is&quot;. To the maximum extent permitted by law, ClippingBase disclaims all warranties and is not liable for any indirect, incidental or consequential damages. Our aggregate liability for any claim will not exceed the fees paid or payable to you in the 12 months preceding the claim.</p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">7. Governing law</h2>
            <p>These Terms are governed by the laws of the jurisdiction in which ClippingBase is incorporated, without regard to conflict-of-law rules.</p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">8. Changes</h2>
            <p>We may update these Terms from time to time. Continued use of the service after changes are posted constitutes acceptance.</p>
          </section>

          <section>
            <h2 className="mb-3 text-xl font-bold text-white">9. Contact</h2>
            <p>Questions? Email <a href="mailto:legal@clippingbase.com" className="text-[#c8ff00] underline">legal@clippingbase.com</a> or use the <Link to="/contact" className="text-[#c8ff00] underline">contact form</Link>.</p>
          </section>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
